import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-LN/report/SafeDrivingScoreDetailGraph/.eu';

export interface GraphData {
  score: number;
  monthName: string;
}

export interface SafeDrivingScoreDetailGraphProps {
  data: [GraphData, GraphData] | [GraphData];
}

export default function SafeDrivingScoreDetailGraph({data}: SafeDrivingScoreDetailGraphProps) {
  return (
    <>
      <Environment.Eu>
        <Environment.Kia>
          <Eu data={data} />
        </Environment.Kia>
      </Environment.Eu>
    </>
  );
}
